import { InviteFunctions } from './invites';
declare const IS_DEV_BUILD: boolean; // The value is supplied by Webpack during the build
declare const VERSION: string; // The value is supplied by Webpack during the build
import * as Sentry from '@sentry/browser';
import { CookieFunctions } from './cookiemessage';
declare let gtag: Function;
// import { Integrations } from '@sentry/tracing';
// import { RewriteFrames } from '@sentry/integrations';

if (!IS_DEV_BUILD) {

  Sentry.init({
    dsn: 'https://68dc5a7baeed492e81f53b29c14868e7@o460993.ingest.sentry.io/5462155',
    release: `v-${VERSION}`,
    // integrations: [new Integrations.BrowserTracing()],
    // tracesSampleRate: 0.25,
    // debug: true,
    // beforeSend(event) {
    //  alert('Event!');
    //  console.log(event);
    //  return event;
    // },
  });

} else {

  // Sentry.init({
  //  dsn: 'https://a14734e2f34e483fb65ac3c289bec28e@o460993.ingest.sentry.io/5462176',
  //  release: `v-${VERSION}`,
  //  integrations: [new Integrations.BrowserTracing()],
  //  tracesSampleRate: 1.0,
  // });
}

export class Join {

  public inviteFunctions: InviteFunctions;
  public cookieFunctions: CookieFunctions;
  private resizeListener: any = null;
  private resizeListenerEvent: any = null;
  private touchstartListener: any = null;
  private touchstartListenerEvent: any = null;
  private isTouch: boolean = false;

  constructor() {
    this.inviteFunctions = new InviteFunctions;
    this.cookieFunctions = new CookieFunctions;
  }

  setupForms() {
    const joinForm = document.querySelector('#joinForm');
    if (joinForm) {
      joinForm.removeEventListener('submit', () => this.inviteFunctions.onSubmit);
      joinForm.addEventListener('submit', () => this.inviteFunctions.onSubmit(joinForm));
    }
    const inviteForm = document.querySelector('#findInviteForm');
    if (inviteForm) {
      inviteForm.removeEventListener('submit', () => this.inviteFunctions.onSubmit);
      inviteForm.addEventListener('submit', () => this.inviteFunctions.onSubmit(inviteForm));
    }
  }

  setupCurrency() {
    const dd = document.querySelector('#selectCurrency');
    if (dd) {
      dd.removeEventListener('change', () => this.inviteFunctions.onCurrencyChange);
      dd.addEventListener('change', () => this.inviteFunctions.onCurrencyChange());
    }
  }

  setupInfoContainers(isResize?: boolean) {
    const ics = Array.from(document.querySelectorAll('.optionscontainer__infocontainer'));
    if (isResize) {
      ics.forEach((ic: any) => {
        ic.style.height = 'auto';
      });
    }
    let maxH: number = 0;
    ics.forEach((ic: any) => {
      maxH = ic.offsetHeight > maxH ? ic.offsetHeight : maxH;
    });
    ics.forEach((ic: any) => {
      if (maxH > ic.offsetHeight) {
        ic.style.height = `${maxH}px`;
      }
    });
    console.log(maxH);
  }

  getCookie(name: String) {
    const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    return v ? v[2] : null;
  }

  analytics() {
    // only submit to analytics if cookie consent allows it!
    // TODO - test event correctly sent to Analytics if cookie consent
    // and not sent if no consent
    const consentCookie = this.getCookie('cpt-cookie-consent');

    if (!consentCookie || consentCookie.indexOf('-analytics') === -1) {
      return;
    }

    // console.log(window.location);
    // console.log(document.title);

    if (typeof (gtag) !== 'undefined') {
      gtag('js', new Date());
      gtag('config', 'G-PMPJFNGGSE');
      // gtag('event', 'page_view', {
        // page_title: document.title,
        //// page_location: window.location.pathname,
        // page_path: window.location.pathname,
      // });
    }
  }

  setupTouchListener() {

    this.touchstartListener = () => {
      if (this.resizeListenerEvent) {
        window.removeEventListener('resize', this.resizeListenerEvent);
      }
      window.addEventListener('orientationchange', this.resizeListenerEvent);
      this.isTouch = true;
      if (this.touchstartListenerEvent) {
        window.removeEventListener('touchstart', this.touchstartListenerEvent);
      }
    };

    this.touchstartListenerEvent = this.touchstartListener.bind(this);
    window.addEventListener('touchstart', this.touchstartListenerEvent);
  }

  setupResizeListener() {

    this.resizeListener = () => {
      this.setupInfoContainers(true);
    };

    this.resizeListenerEvent = this.resizeListener.bind(this);
    window.addEventListener('resize', this.resizeListenerEvent);
  }

}

const joinJs = new Join();
joinJs.setupForms();
joinJs.setupInfoContainers();
joinJs.setupCurrency();
joinJs.cookieFunctions.setupMessage();
joinJs.setupResizeListener();
joinJs.setupTouchListener();
joinJs.inviteFunctions.initialise(true);
joinJs.analytics();
